// import YoutubeVideo from 'react-youtube'
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'
import classNames from 'classnames'

import { TStrapiV4VideoCommonFile } from '../../common-types'

type TProps = {
  data: TStrapiV4VideoCommonFile
  no_padding?: boolean
}

const StrapiV4Video = (props: TProps) => {
  const { data, no_padding = false } = props

  if (!data.videoId) return null

  const width = data.width
  const height = data.height

  const conditionalProps: {
    width?: string | number
    height?: string | number
  } = {}

  if (width) {
    conditionalProps.width = width
  }

  if (height) {
    conditionalProps.height = height
  }

  let jsx = <div />

  jsx = (
    <div
      className={classNames('youtube-video-wrapper w-full', {
        'pt-0': no_padding,
      })}
    >
      {/* <YoutubeVideo
        videoId={data.videoId}
        iframeClassName={`rounded-lg w-full ${
          heightClass ? heightClass : 'h-full'
        }`}
        opts={{
          width: conditionalProps.width,
          height: conditionalProps.height,
          playerVars: {
            origin:
              process.env.NODE_ENV === 'development'
                ? 'https://dev.indmoney.com'
                : 'https://www.indmoney.com',
            modestbranding: 1,
            controls: 0,
            rel: 0,
            iv_load_policy: 3,
          },
        }}
      /> */}
      {/* <div className="overflow-hidden rounded-xl" onClick={on_click}> */}
      <div className="overflow-hidden rounded-xl">
        <LiteYouTubeEmbed
          id={data.videoId}
          title={data.title ?? ''}
          params="controls=0"
          webp
        />
      </div>
    </div>
  )

  return jsx
}

export default StrapiV4Video
